/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */

import { type FireAnalyticsEvent } from '../../common/utils/analytics/types';

type FailedDependency = 'search-combined-config' | 'search-config-ssr' | 'outbound-auth-github';

type onFailedDependencyArgs = {
	dependency: FailedDependency;
	source: string;
	moreContext?: Record<string, unknown>;
};

// Fires an event when a dependency fails outside any request caching.
// Note: should be fired at the application level, so this event matches
// impact on the UX.
export const onFailedDependency = ({
	dependency,
	source,
	moreContext,
}: onFailedDependencyArgs): FireAnalyticsEvent => {
	return {
		source,
		action: 'failedDependency',
		// TODO RAOC-22 migrate analytics off search-specific naming
		actionSubject: 'searchPage',
		eventType: 'track',
		attributes: {
			additionalAttributes: {
				failedDependency: dependency,
				...(moreContext || {}),
			},
		},
	};
};
